var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLithuaniaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "contents"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "var(--fill-0, #55BA07)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_87_19860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "background_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "var(--fill-0, white)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_87_19860)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "top",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V5H20V0H0Z",
    fill: "var(--fill-0, #FECA00)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10V15H20V10H0Z",
    fill: "var(--fill-0, #C51918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLithuaniaFlag);
export default __webpack_public_path__ + "static/media/lithuania-flag.1a4a60dcedf08493fd611487b71398d1.svg";
export { ForwardRef as ReactComponent };